import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import { privateRoutes, publicRoutes } from '@/lib/route.config';
import { PRIVATE_ROUTES } from '@/lib/route.constant';

/**
 * The router.
 *
 * Built at module scope, not inside the component: `createBrowserRouter` holds
 * the history and the loader state, and rebuilding it on a re-render would
 * silently reset both.
 *
 * The catch-all redirects to the dashboard rather than rendering a 404. This is
 * a closed staff portal with a finite, known route table — a mistyped path here
 * is almost always a stale bookmark from a renamed page, and putting the
 * operator somewhere useful beats a dead end. `ProtectedRoute` still applies, so
 * an unauthenticated stray link lands on the login page as it should.
 */
const router = createBrowserRouter([
  ...publicRoutes,
  ...privateRoutes,
  { path: '*', element: <Navigate to={PRIVATE_ROUTES.DASHBOARD} replace /> },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
